module.exports = __webpack_public_path__ + "static/media/Brittany.4ffa76e3.jpeg";